import { render, staticRenderFns } from "./VPrize.vue?vue&type=template&id=a58b0338&"
import script from "./VPrize.vue?vue&type=script&lang=js&"
export * from "./VPrize.vue?vue&type=script&lang=js&"
import style0 from "./VPrize.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports